const pagination = {
    page: 'ページ',
    of: 'の',
    show: '表示',
    showing: '表示中',
    to: '〜',
    items: '件',
    perPage: '件/ページ',
    perPageCount: '{{count}}件/ページ',
    first: '最初',
    previous: '前へ',
    next: '次へ',
    last: '最後',
  };

export default pagination;
